// extracted by mini-css-extract-plugin
export var container = "_p5-0";
export var dotAnimation = "_p5-2";
export var dotsLoading = "_p5-1";